/* PELYKO — ouverture de marque.
   Une fois par session, page d'accueil. Poils qui se rassemblent en empreinte,
   empreinte qui s'ouvre sur la scène de vie, PELYKO, puis la page. Les temps
   vivent dans le CSS (--t-*), le script les lit : une seule partition.
   Respecte « réduire les animations » et les connexions lentes (composition
   fixe, sans vidéo) et retire l'ouverture du DOM dès la fin. */
(() => {
  const root = document.documentElement;
  const el = document.getElementById('pk-entry');
  if (!el || !root.classList.contains('pk-entry-on')) return;
  if (window.__pkEntry) return;
  window.__pkEntry = true;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const conn = navigator.connection || {};
  const slow = !!conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');
  const mode = reduce || slow ? 'static' : 'play';
  const small = window.matchMedia('(max-width: 720px)').matches;

  const svg = el.querySelector('.pk-entry__svg');
  const scene = el.querySelector('[data-pk-intro-scene]');
  const video = el.querySelector('[data-pk-intro-video]');
  const css = getComputedStyle(el);
  const sec = (name, fallback) => { const v = parseFloat(css.getPropertyValue(name)); return isNaN(v) ? fallback : v * 1000; };

  /* ---------- Poils : coordonnées de départ, de dérive et d'arrivée ---------- */
  const buildHairs = (group) => {
    if (!group) return;
    let seed = 20260910;
    const rnd = () => { seed |= 0; seed = (seed + 0x6D2B79F5) | 0; let t = Math.imul(seed ^ (seed >>> 15), 1 | seed); t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t; return ((t ^ (t >>> 14)) >>> 0) / 4294967296; };
    const between = (a, b) => a + (b - a) * rnd();
    /* Contours de l'empreinte (repère du SVG 1000×420) */
    const shapes = [
      { cx: 500, cy: 265, rx: 60, ry: 40, n: 20 },
      { cx: 439, cy: 205, rx: 19, ry: 24, n: 6 },
      { cx: 485, cy: 177, rx: 19, ry: 25, n: 6 },
      { cx: 534, cy: 177, rx: 19, ry: 25, n: 6 },
      { cx: 576, cy: 205, rx: 19, ry: 24, n: 6 }
    ];
    const targets = [];
    shapes.forEach((s) => {
      for (let i = 0; i < s.n; i++) {
        const a = (i / s.n) * Math.PI * 2 + between(-0.12, 0.12);
        targets.push({
          x: s.cx + Math.cos(a) * s.rx, y: s.cy + Math.sin(a) * s.ry,
          r: Math.atan2(Math.cos(a) * s.ry, -Math.sin(a) * s.rx) * 180 / Math.PI
        });
      }
    });
    const d0 = small ? 0.1 : 0.12, span = small ? 0.25 : 0.3;
    const NS = 'http://www.w3.org/2000/svg';
    const frag = document.createDocumentFragment();
    targets.forEach((t, i) => {
      const p = document.createElementNS(NS, 'path');
      p.setAttribute('class', 'pk-entry__hair');
      p.setAttribute('d', 'M-8 0C-3-3 3 3 8 0');
      const sx = between(30, 970), sy = between(10, 410);
      const dx = sx + between(-46, 46), dy = sy + between(-34, 34);
      const sr = between(-70, 70);
      p.style.cssText =
        `--sx:${sx.toFixed(1)}px;--sy:${sy.toFixed(1)}px;--sr:${sr.toFixed(1)}deg;` +
        `--dx:${dx.toFixed(1)}px;--dy:${dy.toFixed(1)}px;--dr:${(sr + between(-28, 28)).toFixed(1)}deg;` +
        `--tx:${t.x.toFixed(1)}px;--ty:${t.y.toFixed(1)}px;--tr:${t.r.toFixed(1)}deg;` +
        `--s:${between(0.9, 1.6).toFixed(2)};--o:${between(0.5, 0.9).toFixed(2)};` +
        `--d:${(d0 + (i / targets.length) * span).toFixed(3)}s`;
      frag.appendChild(p);
    });
    group.appendChild(frag);
  };

  /* ---------- Cadrage de la fenêtre : le masque se cale sur l'empreinte du SVG ----------
     Coussinet à (500, 284) et largeur de l'empreinte 175,8 dans le repère 1000×420. */
  const fit = () => {
    if (!svg || !scene) return;
    const r = svg.getBoundingClientRect();
    scene.style.setProperty('--px', (r.left + r.width * 0.5).toFixed(1) + 'px');
    scene.style.setProperty('--py', (r.top + r.height * (284.15 / 420)).toFixed(1) + 'px');
    scene.style.setProperty('--pw', (r.width * 0.1758).toFixed(1) + 'px');
  };

  /* ---------- Cycle de vie ---------- */
  const timers = [];
  let done = false;
  /* Le hero enchaîne sur cet événement : sa scène démarre quand le rideau se lève. */
  const announce = () => { try { document.dispatchEvent(new CustomEvent('pk-intro-leaving')); } catch (e) {} };
  const finish = () => {
    if (done) return;
    done = true;
    announce();
    timers.forEach(clearTimeout);
    root.classList.remove('pk-entry-on');
    try { if (video) { video.pause(); video.removeAttribute('src'); video.load(); } } catch (e) {}
    el.remove();
  };
  const leave = (fast) => {
    el.classList.add('is-leaving');
    announce();
    if (fast) {
      el.style.transition = 'opacity .22s ease';
      el.style.animation = 'none';
      el.style.opacity = '0';
      timers.push(setTimeout(finish, 240));
    }
  };

  /* Vidéo : on ne l'affiche que si elle joue vraiment ; sinon le poster reste. */
  const startVideo = () => {
    if (!video || !video.getAttribute('src')) return;
    video.addEventListener('playing', () => scene.classList.add('has-video'), { once: true });
    const p = video.play();
    if (p && p.catch) p.catch(() => {});
    /* Le hero lance sa propre copie de la scène au même instant : fondu continu. */
    try { document.dispatchEvent(new CustomEvent('pk-intro-scene')); } catch (e) {}
  };

  if (mode === 'play') { buildHairs(el.querySelector('[data-pk-hairs]')); fit(); }

  const skip = el.querySelector('[data-pk-skip]');
  if (skip) skip.addEventListener('click', () => leave(true), { once: true });
  const onKey = (e) => { if (e.key === 'Escape') { leave(true); document.removeEventListener('keydown', onKey); } };
  document.addEventListener('keydown', onKey);
  window.addEventListener('resize', fit, { passive: true });

  const tScene = sec('--t-scene', 2050);
  const tOut = mode === 'play' ? sec('--t-out', 3550) : 1150;
  const tEnd = tOut + (mode === 'play' ? 450 : 370);

  /* Démarrage sur le prochain rendu pour que les styles initiaux soient posés */
  requestAnimationFrame(() => {
    fit();
    el.classList.add(mode === 'play' ? 'is-playing' : 'is-static');
    if (mode === 'play') timers.push(setTimeout(startVideo, Math.max(0, tScene - 220)));
    timers.push(setTimeout(() => leave(false), tOut));
    timers.push(setTimeout(finish, tEnd));
  });

  /* Onglet caché pendant l'ouverture : on ne fait pas attendre au retour */
  document.addEventListener('visibilitychange', () => { if (document.hidden) finish(); }, { once: true });
})();
